import { LoadingOutlined } from "@ant-design/icons";
import {Carousel, Empty} from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {Bahan, Jahitan, Custom, Tokopedia, Shopee, Lazada, IcJacket, IcShirt, IcTrouser } from '../../assets/img';
import { Marketplace, Product, Services } from "../../components";
import MARKETPLACE from "../../config/Marketplace";
import {
  getShirt,
  getDataTrouser,
  getDataJacket,
  getDataSlider,
} from '../../config/Redux/action';

const Home = () => {
  const loading = useSelector((state) => state.product.isLoading);
  let dataAosIcrement = 500;
  const dispatch = useDispatch();
  const [shirts, setShirts] = useState([]);
  const [trousers, setTrousers] = useState([]);
  const [jackets, setJackets] = useState([]);
  const [sliders, setSliders] = useState([]);
  useEffect(() => {
    const getData = async () => {
      const resShirt = await dispatch(getShirt());
      setShirts(resShirt)
      const resTrouser = await dispatch(getDataTrouser());
      setTrousers(resTrouser);
      const resJacket = await dispatch(getDataJacket());
      setJackets(resJacket);
      const resSlider = await dispatch(getDataSlider());
      console.log(resSlider);
      setSliders(resSlider);
    }
    getData();
  },[dispatch])

  const totalShirt = shirts.filter((shirt) => shirt.data.publish === 'published');
  const totalTrouser = trousers.filter((trouser) => trouser.data.publish === 'published');
  const totalJacket = jackets.filter((jacket) => jacket.data.publish === 'published');

  return (
    <div id='home'>
      <section className='hero' style={{ marginTop: '73px' }}>
        <Carousel autoplay>
          {loading ? (
            <LoadingOutlined className='loadingProduct' />
          ) : (
            sliders.map((slider) => {
              return (
                <div>
                  <div className='hero-container'>
                    <div
                      className='content'
                      style={{
                        backgroundImage: `url(${slider.data.image_url})`,
                      }}
                    >
                      <h1 style={{ color: '#fff' }}>{slider.data.title}</h1>
                      <p>{slider.data.subtitle}</p>
                    </div>
                  </div>
                </div>
              );
            })
          )}
        </Carousel>
      </section>

      <main>
        <section className='iconProduct'>
          <div className='icon'>
            <img src={IcShirt} width={50} height={50} alt='Icon Shirt' />
            <p>
              {totalShirt.length} <span>Kaos</span>
            </p>
          </div>
          <div className='icon'>
            <img src={IcTrouser} width={50} height={50} alt='Icon Shirt' />
            <p>
              {totalTrouser.length} <span>Celana</span>
            </p>
          </div>
          <div className='icon'>
            <img src={IcJacket} width={50} height={50} alt='Icon Shirt' />
            <p>
              {totalJacket.length} <span>Jaket</span>
            </p>
          </div>
        </section>
        <section className='shirt'>
          <h1 data-aos='fade-right'>Produk Kaos</h1>
          {loading ? (
            <LoadingOutlined className='loadingProduct' />
          ) : (
            <div
              className={totalShirt.length > 0 ? 'product-content' : 'empty'}
            >
              {totalShirt.length > 0 ? (
                shirts
                  .filter(
                    (shirt, index) =>
                      shirt.data.publish === 'published' && index < 4,
                  )
                  .map((shirt) => {
                    return (
                      <Product
                        delay={(dataAosIcrement += 200)}
                        key={shirt.id}
                        link={`/shirt/detail/${shirt.id}`}
                        image={shirt.data.image_url}
                        name={shirt.data.name}
                        normalPrice={shirt.data.price}
                        discount={shirt.data.promoPrice}
                      />
                    );
                  })
              ) : (
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
              )}
            </div>
          )}
        </section>
        <section className='trouser'>
          <h1 data-aos='fade-right'>Produk Celana</h1>
          {loading ? (
            <LoadingOutlined className='loadingProduct' />
          ) : (
            <div
              className={totalTrouser.length > 0 ? 'product-content' : 'empty'}
            >
              {totalTrouser.length > 0 ? (
                trousers
                  .filter(
                    (trouser, index) =>
                      trouser.data.publish === 'published' && index < 4,
                  )
                  .map((trouser, index) => {
                    return (
                      <Product
                        delay={(dataAosIcrement += 200)}
                        key={trouser.id}
                        link={`/trouser/detail/${trouser.id}`}
                        image={trouser.data.image_url}
                        name={trouser.data.name}
                        normalPrice={trouser.data.price}
                        discount={trouser.data.promoPrice}
                      />
                    );
                  })
              ) : (
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
              )}
            </div>
          )}
        </section>
        <section className='jacket'>
          <h1 data-aos='fade-right'>Produk Jaket</h1>
          {loading ? (
            <LoadingOutlined className='loadingProduct' />
          ) : (
            <div
              className={totalJacket.length > 0 ? 'product-content' : 'empty'}
            >
              {totalJacket.length > 0 ? (
                jackets
                  .filter(
                    (jacket, index) =>
                      jacket.data.publish === 'published' && index < 4,
                  )
                  .map((jacket, index) => {
                    return (
                      <Product
                        delay={(dataAosIcrement += 200)}
                        key={jacket.id}
                        link={`/jacket/detail/${jacket.id}`}
                        image={jacket.data.image_url}
                        name={jacket.data.name}
                        normalPrice={jacket.data.price}
                        discount={jacket.data.promoPrice}
                      />
                    );
                  })
              ) : (
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
              )}
            </div>
          )}
        </section>
        <section className='services'>
          <h1 data-aos='fade-right'>Pelayanan</h1>
          <div className='services-container'>
            <Services
              delay={500}
              image={Bahan}
              title={'Bahan'}
              desc={
                'Bahan yang kami sediakan berkualitas tinggi dan sangat nyaman untuk digunakan'
              }
            />
            <Services
              delay={700}
              image={Jahitan}
              title={'Produksi'}
              desc={
                'Proses produksi mulai dari potong bahan, pembuatan baju, sablon, hingga pengemasan dilakukan oleh para ahli'
              }
            />
            <Services
              delay={900}
              image={Custom}
              title={'Produk Custom'}
              desc={
                'Menyediakan pembuatan baju, celana, jaket custom (bisa menghubungi Dudi)'
              }
            />
          </div>
        </section>
        <section className='marketplace'>
          <h1 data-aos='fade-right'>MarketPlace</h1>
          <div className='content'>
            <a
              href={MARKETPLACE.tokopedia}
              target='_blank'
              rel='noopener noreferrer'
            >
              <Marketplace delay={500} title='Tokopedia' image={Tokopedia} />
            </a>
            <a
              href={MARKETPLACE.shopee}
              target='_blank'
              rel='noopener noreferrer'
            >
              <Marketplace delay={700} title='Shopee' image={Shopee} />
            </a>
            <a
              href={MARKETPLACE.lazada}
              target='_blank'
              rel='noopener noreferrer'
            >
              <Marketplace delay={900} title='Lazada' image={Lazada} />
            </a>
          </div>
        </section>
      </main>
    </div>
  );
}

export default Home;